export const CATEGORY_COLORS = {
  civilisations: "#b45309",
  monuments: "#57534e",
  tresors: "#d97706",
  epaves: "#0369a1",
  ovnis: "#15803d",
  creatures: "#065f46",
  legendes: "#7c3aed",
  villes: "#0f766e",
  ia: "#be185d",
  militaires: "#374151",
  temporels: "#4338ca",
};

export const CATEGORY_ICONS = {
  civilisations: "🏛",
  monuments: "🗿",
  tresors: "💰",
  epaves: "⚓",
  ovnis: "👽",
  creatures: "👣",
  legendes: "📖",
  villes: "🌎",
  ia: "🔍",
  militaires: "🛡",
  temporels: "⏳",
};

export const I18N = {
  fr: {
    title: "La seule carte dont vous aurez besoin",
    subtitle: "Chasse aux trésors • Légendes • OVNIs • Et bien plus",
    exploreBtn: "Explorer la carte",
    profileBtn: "Mon profil",
    adventurerMode: "Mode Aventurier",
    adventurerHelp: "Utilise ta position GPS pour valider ta visite (rayon 50 m)",
    visitHere: "Valider ma visite",
    visited: "Lieu visité",
    tooFar: "Vous êtes trop loin",
    visitSuccess: "Visite validée !",
    locationDenied: "Autorisez la géolocalisation dans votre navigateur",
    photosVideos: "Photos & vidéos",
    uploadMedia: "Ajouter une photo/vidéo",
    uploading: "Envoi…",
    uploaded: "Média publié",
    uploadError: "Erreur d'envoi",
    profile: "Mon profil aventurier",
    totalVisits: "Lieux visités",
    progression: "Progression",
    badges: "Badges",
    nextBadge: "Prochain badge",
    categoriesExplored: "Catégories explorées",
    recentVisits: "Visites récentes",
    noVisits: "Aucune visite pour l'instant. Sortez explorer !",
    of: "sur",
    presentation: "La seule carte dont vous aurez besoin est une carte interactive qui rassemble les plus grands mystères, découvertes et légendes de notre planète en un seul endroit.",
    presentation2: "Explorez les civilisations anciennes, les monuments historiques, les trésors perdus, les épaves célèbres, les observations d'OVNIs, les créatures légendaires et les légendes urbaines du monde entier.",
    presentation3: "Grâce à une intelligence artificielle, le site analyse de grandes quantités de données publiques provenant de l'histoire, de l'archéologie, de la géographie, du climat et d'autres informations disponibles afin de répertorier les lieux connus et de proposer des zones hypothétiques.",
    disclaimerTitle: "Avertissement",
    disclaimer: "Ce site combine des informations historiques vérifiées, des récits folkloriques et des hypothèses ou créations fictives générées par une intelligence artificielle. Les emplacements et récits proposés par l'IA sont clairement identifiés et ne constituent pas des découvertes confirmées. Ce projet est destiné à l'exploration, à l'apprentissage et à la curiosité.",
    searchPlaceholder: "Rechercher un pays, une ville, un monument…",
    filters: "Catégories",
    filterAll: "Toutes",
    filterNone: "Aucune",
    aiAnalysis: "Analyse IA",
    generateAi: "Générer l'analyse IA",
    generating: "L'IA analyse…",
    confidence: "Niveau de confiance",
    coordinates: "Coordonnées",
    sources: "Sources",
    country: "Pays",
    hypothesis: "Hypothèse",
    confirmed: "Confirmé",
    fictional: "Création IA",
    comments: "Commentaires",
    loginToComment: "Connectez-vous pour commenter",
    signInGoogle: "Se connecter avec Google",
    signOut: "Se déconnecter",
    postComment: "Publier",
    yourComment: "Partagez votre découverte ou expérience…",
    noComments: "Soyez le premier à commenter ce lieu.",
    close: "Fermer",
    backHome: "Retour",
    resultsFound: "résultats trouvés",
    placesCount: "lieux répertoriés",
    aiPowered: "IA embarquée",
    atlasTag: "Atlas de l'Inconnu",
  },
  en: {
    title: "The Only Map You Will Ever Need",
    subtitle: "Treasure Hunt • Legends • UFOs • And So Much More",
    exploreBtn: "Explore the map",
    profileBtn: "My profile",
    adventurerMode: "Adventurer Mode",
    adventurerHelp: "Use your GPS to validate your visit (50 m radius)",
    startAdventure: "Enable geolocation",
    stopAdventure: "Disable",
    visitHere: "Check in here",
    visited: "Visited",
    tooFar: "You are too far",
    visitSuccess: "Visit validated!",
    locationDenied: "Allow geolocation in your browser",
    photosVideos: "Photos & videos",
    uploadMedia: "Add photo/video",
    uploading: "Uploading…",
    uploaded: "Media posted",
    uploadError: "Upload failed",
    profile: "My Adventurer Profile",
    totalVisits: "Places visited",
    progression: "Progress",
    badges: "Badges",
    nextBadge: "Next badge",
    categoriesExplored: "Categories explored",
    recentVisits: "Recent visits",
    noVisits: "No visits yet. Go explore!",
    of: "of",
    presentation: "The Only Map You Will Ever Need is an interactive map that gathers our planet's greatest mysteries, discoveries and legends in a single place.",
    presentation2: "Explore ancient civilizations, historical monuments, lost treasures, famous shipwrecks, UFO sightings, legendary creatures and urban legends from around the world.",
    presentation3: "Powered by AI, the site analyzes large amounts of public data from history, archaeology, geography, climate and other sources to catalogue known locations and propose hypothetical zones for further exploration.",
    disclaimerTitle: "Disclaimer",
    disclaimer: "This site combines verified historical information, folkloric accounts and AI-generated hypotheses or fictional creations. AI-proposed locations and stories are clearly identified and are not confirmed discoveries. This project is intended for exploration, learning and curiosity.",
    searchPlaceholder: "Search country, city, monument…",
    filters: "Categories",
    filterAll: "All",
    filterNone: "None",
    aiAnalysis: "AI Analysis",
    generateAi: "Generate AI analysis",
    generating: "AI analyzing…",
    confidence: "Confidence level",
    coordinates: "Coordinates",
    sources: "Sources",
    country: "Country",
    hypothesis: "Hypothesis",
    confirmed: "Confirmed",
    fictional: "AI creation",
    comments: "Comments",
    loginToComment: "Sign in to comment",
    signInGoogle: "Sign in with Google",
    signOut: "Sign out",
    postComment: "Post",
    yourComment: "Share your discovery or experience…",
    noComments: "Be the first to comment on this location.",
    close: "Close",
    backHome: "Back",
    resultsFound: "results found",
    placesCount: "catalogued places",
    aiPowered: "AI-powered",
    atlasTag: "Atlas of the Unknown",
  },
};
